module.exports = __webpack_public_path__ + "img/Stryker.1a0257b4.png";